module.exports = {"350703001":"潭城街道","350703002":"童游街道","350703102":"将口镇","350703103":"徐市镇","350703104":"莒口镇","350703105":"麻沙镇","350703106":"黄坑镇","350703107":"水吉镇","350703108":"漳墩镇","350703109":"小湖镇","350703200":"崇雒乡","350703201":"书坊乡","350703202":"回龙乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350703.json
// module id = 1333
// module chunks = 0